import Immutable from 'immutable';
import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

// action creators
import { doneIndicator, success } from 'store/actions/httpActions';

// api
import client from 'sources/api';

// constants
import {
  MESSAGE_UPDATE_REQUEST,
  MESSAGE_UPDATE,
} from 'store/constants/messageTypes';

// schemas
import { messageSchema } from 'store/schemas/messageSchema';

// helpers
import httpSaga from 'store/sagas/httpSaga';
import getResponsePayload from 'helpers/getResponsePayload';

const WATCH_TYPE = MESSAGE_UPDATE_REQUEST;
const TYPE = MESSAGE_UPDATE;
const META_ID = 'update';

export function* updateMessageSaga(action: any): any {
  const {
    payload: { id, groupId, body, scheduledAt: scheduled_at },
  } = action;

  // @ts-expect-error ts-migrate(2569) FIXME: Type 'Generator<any, any, unknown>' is not an arra... Remove this comment to see the full error message
  const response = yield* httpSaga(
    TYPE,
    call(client.patch, `/messages/${id}?group_id=${groupId}`, {
      body,
      scheduled_at,
    }),
    {
      metaId: META_ID,
      dispatchSuccess: false,
    }
  );

  // No response means httpSaga already put the error on the store
  if (response) {
    const payload = getResponsePayload(response, messageSchema);
    yield put(success(TYPE, Immutable.fromJS(payload), META_ID));
  }

  yield put(doneIndicator(TYPE));
}

export function* watch() {
  yield takeEvery(WATCH_TYPE, updateMessageSaga);
}

export default function* root() {
  yield all([fork(watch)]);
}
